import React from 'react';
import PropTypes from 'prop-types';
import { Button, Text } from '../../Atoms';
import { Input } from '../../Molecules';
import { PhotoLoginOrganisme } from '../../Organisms';
import KeycloakService, {
  forgotPasswordLink
} from '../../Services/KeycloakService';
function TemplateFirstLoginStep1(props) {
  return (
    <div className="login-template login-padding-bottom">
      <div className="login-template-organism">
        <div className="login-container"> 
            <Text
            text="Bienvenue sur votre espace assuré !"
            type="title-42"
            className="login-welcome-text"
          />
          <div className='first-login-divider' />
          <div>
            <Text
              text="Première connexion"
              type="h7"
              className="login-title-text"
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'left'
              }}
            >
              <Text
                text="Merci de vous munir de votre adresse email ou numéro d’adhérent lié à votre contrat, que vous pouvez retrouver sur votre lettre de bienvenue."
                className="text-description-first-login"
              />
            </div>
            <div className="first-login-small-container">
              <Input
                placeholder="Email ou numéro d’adhérent"
                className={
                  props.msgError !== ''
                    ? 'input-first-login-error'
                    : 'input-first-login'
                }
                onChange={(e) => props.onChange(e.target.value)}
                value={props.mail}
              />
              {props.msgError !== '' && (
                <div className="error-msg-container">
                  {props.msgError}
                </div>
              )}

              <div>
                {props.shouldShowForgotLink == true && (
                  <span
                    onClick={() => (window.location.href = forgotPasswordLink)}
                  >
                    <Text
                      text="Mot de passe oublié ?"
                      type="h6"
                      className="forget-password-link"
                    />
                  </span>
                )}
              </div>

              <div className="btn-next-first-login-container">
                <Button
                  text="Suivant"
                  className="btn-next-first-login"
                  boxShadow
                  icon="arrow-right"
                  iconRight={true}
                  onClick={() => props.nextStep()}
                />
              </div>
               <div className="mt-20">
                  <Button
                    text="Retour"
                    className="btn-back-first-login"
                    icon="arrow-left"
                    boxShadow
                    onClick={() => KeycloakService.doLogin()}
                  />
               </div>
            </div>
          </div>
        </div>
      </div>
        <PhotoLoginOrganisme />
    </div>
  );
}

TemplateFirstLoginStep1.propTypes = {
  msgError: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  mail: PropTypes.string,
  shouldShowForgotLink: PropTypes.bool,
  nextStep: PropTypes.func.isRequired
};

export default TemplateFirstLoginStep1;

